import { __extends } from "tslib";
import { GetImportJobsRequest, GetImportJobsResponse } from "../models/index";
import { deserializeAws_restJson1GetImportJobsCommand, serializeAws_restJson1GetImportJobsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetImportJobsCommand = /** @class */ (function (_super) {
    __extends(GetImportJobsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetImportJobsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetImportJobsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetImportJobsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetImportJobsResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetImportJobsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetImportJobsCommand(input, context);
    };
    GetImportJobsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetImportJobsCommand(output, context);
    };
    return GetImportJobsCommand;
}($Command));
export { GetImportJobsCommand };
//# sourceMappingURL=GetImportJobsCommand.js.map